<!-- src/components/TopHeader.vue -->
<template>
  <div>

    <!-- 轮播图 -->
    <el-carousel :interval="5000" height="70vh" class="medical-carousel" indicator-position="outside">
      <!-- 第一屏 -->
      <el-carousel-item>
        <div class="carousel-layer">
          <div class="carousel-bg" :style="{ backgroundImage: 'url(' + banner1 + ')' }"></div>
        </div>
      </el-carousel-item>

      <!-- 第二屏 -->
      <el-carousel-item>
        <div class="carousel-layer">
          <div class="carousel-bg" :style="{ backgroundImage: 'url(' + banner2 + ')' }"></div>
        </div>
      </el-carousel-item>
      <!-- 第三屏 -->
      <el-carousel-item>
        <div class="carousel-layer">
          <div class="carousel-bg" :style="{ backgroundImage: 'url(' + banner3 + ')' }"></div>
        </div>
      </el-carousel-item>
      <!-- 自定义指示器 -->
      <template #indicator="{ index }">
        <div class="custom-indicator">
          <span :class="{ active: currentIndex === index }"></span>
        </div>
      </template>
    </el-carousel>
    <!-- 主要产品 -->
    <div class="ProductText">主要产品</div>
    <div class="box1" @mouseover="hover = true" @mouseleave="hover = false">
      <div class="product-container" :class="{ 'hover-effect': hover }">
        <!-- 左边图片区 -->
        <div class="image-box">
          <img src="../assets/zycptu1.jpg" alt="产品图片">
        </div>

        <!-- 右边内容区 -->
        <div class="content-box">
          <h3 class="title">ai视力智能快速筛查仪</h3>
          <p class="description">
            采用AI图像识别技术，实现精准视力检测<br>
            支持快速筛查与数据分析<br>
            适用年龄：0-18岁
          </p>
          <el-button type="primary" class="detail-btn" @click="ViewDetails">查看详情</el-button>
        </div>
      </div>
    </div>


    <Footer />
  </div>

</template>

<script>
import Footer from '@/components/Footer.vue';
export default {
  name: 'HomeView',
  data() {
    return {
      hover: [false, false],// 当前轮播图索引 // 为每个盒子分配独立的 hover 状态
      banner1: require('@/assets/shuc1.jpg'), // 引入本地图片
      banner2: require('@/assets/shuc2.jpg'), // 引入本地图片
      banner3: require('@/assets/shuc3.jpg'), // 引入本地图片
      currentIndex: 0
    }
  },

  methods: {
    ViewDetails() {
      this.$router.push('/CompanyProducts'); // 跳转到目标页面
    }
  },
  components: {
    Footer
  }

}
</script>

<style scoped>
.box1 {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}

/* 轮播图 */
.medical-carousel {
  position: relative;
  margin-top: 60px;
  /* 与顶部导航栏间距 */
}

.carousel-layer {
  position: relative;
  height: 100%;
}

.carousel-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}





.product-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.product-card {
  text-align: center;
  padding: 1.5rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  transition: transform 0.3s;
}

.product-card:hover {
  transform: translateY(-5px);
}


.product-title {
  font-size: 1.2rem;
  margin: 1rem 0;
}

.product-desc {
  font-size: 0.9rem;
  color: #ddd;
}


@media (max-width: 768px) {
  .main-title {
    font-size: 1.8rem;
  }

  .product-grid {
    grid-template-columns: 1fr;
  }
}

/* 底部主要产品 */
.ProductText {
  font-size: 30px;
  margin: 50px;
  justify-content: center;
  display: flex;
}



/* 产品容器 */
.product-container {
  display: flex;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 20px;
  transition: all 0.3s ease;
  width: 1000px;
}

/* 悬停效果 */
.hover-effect {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

/* 图片容器 */
.image-box {
  flex: 0 0 40%;
  padding: 10px;
  min-height: 250px;
}

.image-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}

/* 内容容器 */
.content-box {
  flex: 1;
  padding: 20px;
  margin-left: 30px;
}

.title {
  color: #303133;
  font-size: 24px;
  margin-bottom: 15px;
}

.description {
  color: #606266;
  line-height: 1.8;
  font-size: 16px;
  margin-bottom: 25px;
}

.detail-btn {
  padding: 12px 30px;
  border-radius: 20px;
  font-size: 16px;
}
</style>